import(/* webpackMode: "eager" */ "/app/src/app/(tabs)/layout.tsx");
